export default __webpack_public_path__ + "static/media/icon-double-house.80892268.svg";